import { createLocalStorageSync } from './use-local-storage-sync'

export type WeeklyViewStyle = 'dots' | 'heatmap'

export const useWeeklyViewStyle = createLocalStorageSync<WeeklyViewStyle>(
  'weekly-view-style',
  'dots',
  (raw) => (raw === 'dots' || raw === 'heatmap' ? raw : null),
)
